/** @jsx jsx */
import { jsx } from '@emotion/react';

import { useState } from 'react';

import { Button } from '@coursera/cds-core';
import { ChevronDownIcon, ChevronUpIcon } from '@coursera/cds-icons';

import LevelInformation from 'bundles/program-skills-objectives/components/ProgramSkillRecommendationsPage/LevelSetsResultModal/LevelInformation';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import { TrackedButton } from 'bundles/program-skills-objectives/components/ProgramSkillRecommendationsPage/LevelSetsResultModal/LevelSetsResultBody';

import _t from 'i18n!nls/program-skills-objectives';

type LevelSetLevel = {
  levelName: string;
  minValue: number;
  maxValue: number;
};

type Props = {
  levels: LevelSetLevel[];
};

const LevelSetScoringSystemLabel = ({ levels }: Props) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <div css={{ width: '100%', display: 'flex', flexDirection: 'column', paddingBottom: 'var(--cds-spacing-200)' }}>
      <TrackedButton
        {...Button.defaultProps}
        trackingName="toggle_scoring_system"
        css={{ marginLeft: 'auto', marginRight: -16 }}
        onClick={() => setExpanded(!expanded)}
        variant="ghost"
        iconPosition="after"
        aria-expanded={expanded}
        aria-controls="levelsetScoringSystem"
        icon={expanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
      >
        {_t('View scoring system')}
      </TrackedButton>
      {expanded && (
        <ol css={{ padding: 0 }} id="levelsetScoringSystem">
          {levels.map((level) => (
            <LevelInformation key={level.levelName} {...level} />
          ))}
        </ol>
      )}
    </div>
  );
};

export default LevelSetScoringSystemLabel;
